import { useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

// Ortak lookuplar (marka/kullanıcı/tip)
export function useLookups() {
  const [brands, setBrands] = useState([]);
  const [users, setUsers] = useState([]);
  const [types, setTypes] = useState([]);
  useEffect(() => {
    api.get('/pm/brands').then(r => setBrands(r.data)).catch(() => {});
    api.get('/pm/users').then(r => setUsers(r.data)).catch(() => {});
    api.get('/pm/task-types').then(r => setTypes(r.data)).catch(() => {});
  }, []);
  return { brands, users, types };
}

// 3 bucket + scorecard (opsiyonel account_id ve filtre)
export function useBoard({ accountId, scope } = {}) {
  const [buckets, setBuckets] = useState({ upcoming: [], overdue: [], inprogress_no_due: [], incomplete: [] });
  const [score, setScore] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ assignee: [], brand: [], type: [] });
  const [showDone, setShowDone] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    const q = (bucket) => {
      const p = new URLSearchParams();
      p.set('bucket', bucket);
      if (accountId) p.set('account_id', accountId);
      if (filters.assignee[0]) p.set('assignee', filters.assignee[0]);
      if (filters.brand[0] && !accountId) p.set('account_id', filters.brand[0]);
      if (filters.type[0]) p.set('type', filters.type[0]);
      return api.get(`/pm/tasks?${p.toString()}`).then(r => r.data);
    };
    try {
      const [up, ov, ip, inc] = await Promise.all([
        q('upcoming'), q('overdue'), q('inprogress_no_due'), q(showDone ? 'all' : 'incomplete'),
      ]);
      setBuckets({ upcoming: up, overdue: ov, inprogress_no_due: ip, incomplete: inc });
      const sp = accountId
        ? await api.get(`/pm/brands/${accountId}/summary`)
        : await api.get(`/pm/scorecards${scope ? `?scope=${scope}` : ''}`);
      setScore(sp.data);
    } catch (e) { /* noop */ }
    finally { setLoading(false); }
  }, [accountId, scope, filters, showDone]);

  useEffect(() => { load(); }, [load]);

  const patch = async (id, body) => {
    await api.patch(`/pm/tasks/${id}`, body);
    load();
  };
  return { buckets, score, loading, filters, setFilters, showDone, setShowDone, reload: load, patch };
}
